export default "__VITE_ASSET__1a5c016a__"